<template>
    <el-card shadow="hover">
        <label slot="header">导入向导</label>
        <el-divider content-position="left">默认action上传至文件服务， 模板文件名称template="j-import.xlsx" 上传时附带信息:post-data="{ bucketName: 'grid' }"(默认不自动上传，需要点击导入按钮，将文件上传至后台)</el-divider>
        <span class="common-link-pointer" @click="showImport = true">点击导入上传</span>
        <j-import v-if="showImport" :close.sync="showImport" template="j-import.xlsx" :post-data="{ bucketName: 'grid' }" />
        <el-divider content-position="left">默认action上传至文件服务， 模板文件名称template="j-import.xlsx" 上传时附带信息:post-data="{ bucketName: 'grid' }"(选择文件后自动上传)</el-divider>
        <span class="common-link-pointer" @click="showAutoImport = true">自动上传</span>
        <el-divider content-position="left">限制上传文件格式，文件大小:mime-type-limit="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']" :size-limit="1"</el-divider>
        <span class="common-link-pointer" @click="showLimitImport = true">只能上传1MB的xlsx或xls文件</span>
        <j-import v-if="showLimitImport" :close.sync="showLimitImport" template="j-import.xlsx" :post-data="{ bucketName: 'grid' }" :mime-type-limit="['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']" :size-limit="1" />
        <el-divider content-position="left">根据不同接口的后端返回键值对匹配列表数据，设置结果列表显示</el-divider>
        <el-table :data="tableData">
            <el-table-column prop="name" label="字段名" show-overflow-tooltip width="100px" />
            <el-table-column prop="desc" label="示例" show-overflow-tooltip />
        </el-table>
    </el-card>
</template>

<script>
    import JImport from "./JImport";
    export default {
        components: {
            JImport
        },
        data() {
            return {
                showLimitImport: false,
                showAutoImport: false,
                showImport: false,
                tableData: [
                    { name: 'tables', desc: '接收数组，后端返回的错误列表字段，多个错误列表会合并数组显示, 默认[\'errorInfo\', \'replicationInfo\']' },
                    { name: 'columnProps', desc: '接收数组，需要显示具体的属性名，多个错误列表属性名不同，属性名逗号分割, 默认[\'name,title\', \'errorMsg,error\']' },
                    { name: 'columnNames', desc: '接收数组，对应属性名顺序显示的中文描述, 默认[\'名称\', \'错误原因\']' },
                ]
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
